import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=0b9eeb8e&scoped=true"
import script from "./uploadPhoto.vue?vue&type=script&lang=js"
export * from "./uploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=0b9eeb8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9eeb8e",
  null
  
)

export default component.exports